<template>
    <div v-if="loading_ppn === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <input v-model="ppn.pf_ppn" id="pf_ppn" type="text" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="11">
          <label for="pf_ppn">Número</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="ppn.pf_ppn_emissao" v-mask="['##/##/####']" id="ppn_dt_emissao" type="text">
          <label for="ppn_dt_emissao">Data de Emissão</label>
        </div>
        <div class="input-field col s12 m12">
            <button @click="prepareSubmitPpn" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'PisPasepNit',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_ppn: false,
      doc_hash: 'dhar00',
      meta: this.$store.state.meta.data,
      routeMatched: this.$route.name,
      locked: false,
      ppn: {
        pf_ppn: this.doc.ppn,
        pf_ppn_emissao: (verificaData(this.doc.emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.emissao) : null),
      },
      error_fields: {},
      loaded: null,      
    }
  },
  computed: {
    verificaForm: function() {
      let status = this.ppn.pf_ppn != undefined && this.ppn.pf_ppn.length > 2 && (!this.ppn.pf_ppn_emissao || verificaData(this.ppn.pf_ppn_emissao) === true)

      status = true; // temporario
      this.$emit('statusChange', {
        doc: 2, 
        status: status
      })
      return status
    }
  },
  methods: {
    async submitInsertPpn(ppn){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/ppn/`, {
        ...ppn,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_ppn = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 1)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_ppn = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitPpn(){
      this.loading_ppn = true

      let ppn = {
        pf_id: this.pf_id,
        pf_ppn: this.ppn.pf_ppn,
        pf_ppn_emissao: (verificaData(this.ppn.pf_ppn_emissao, 'YYYY-MM-DD') === true ? formataData(this.ppn.pf_ppn_emissao) : null),
      }
      if(this.loaded !== sha1(JSON.stringify(ppn))){
        return this.submitInsertPpn(ppn)
      } else {
        this.loading_ppn = false
        this.$emit('docSaved', 1)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      let keys = [
        'pf_ppn'
      ]

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.ppn[key] == null || this.ppn[key] == ''){
          status = true // deve permitir salvar vazio (temporario)
          this.$set(this.error_fields, key, false)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })
    }
  },
  watch: {
    ppn: {
      handler: function(updated_perfil, old_perfil){
        setTimeout(() => {
          this.changed = true
          this.step_completed = this.verificaStatusDocumento()
        }, 300)
      },
      deep: true
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_ppn: this.ppn.pf_ppn,
      pf_ppn_emissao: (verificaData(this.ppn.pf_ppn_emissao, 'YYYY-MM-DD') === true ? formataData(this.ppn.pf_ppn_emissao) : null),
    }))
    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/Pispasepnit.vue